import styled from 'styled-components'
import { theme } from '../../../theme/theme'

export const Title = styled.h3`
    padding: ${theme.space.md} 0 ${theme.space.lg} ${theme.space.md};
    border-radius: 10px 10px 0 0;
    margin: 0;
    background: #F00;
`
